<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div
        class="card-header align-items-center justify-content-between border-0"
      >
        <h5 class="card-title font-bold">مدیرت امتیازات باشگاه</h5>
        <button
          :disabled="disabled"
          type="button"
          @click="submitChanges"
          class="btn btn-success"
        >
          ثبت تغییرات
        </button>
      </div>
      <div class="card-body">
        <b-table
          :style="{ opacity: disabled ? '0.6' : 1 }"
          bordered
          responsive
          striped
          small
          v-if="items && items.length"
          :fields="fields"
          :items="items"
        >
          <template v-slot:cell(id)="data">
            {{ data.item.id }}
          </template>
          <template v-slot:cell(title)="data">
            <b-form-input type="text" v-model="data.item.title" />
          </template>
          <template v-slot:cell(bon_value)="data">
            <b-form-input type="number" v-model="data.item.bon_value" />
          </template>
          <template v-slot:cell(score_value)="data">
            <b-form-input type="number" v-model="data.item.score_value" />
          </template>
        </b-table>
        <div v-else class="alert alert-info">
          موردی یافت نشد
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import scoreSettingsImpl from "@@/core/pages/customerClub/clubSettings/scoreSettings/scoreSettingsImpl.js";
export default {
  extends: scoreSettingsImpl,
};
</script>
